import React from "react";
import Spinner from "@/components/loader/Spinner";

const PageLoader = ({
  children,
  isFetching,
}: {
  children: React.ReactNode;
  isFetching: boolean;
}) => {
  return <>{isFetching ? <Spinner /> : children}</>;
};

export default PageLoader;
